/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
.ux-iws-teaser-magazine {
    display: block;
    position: relative;
    width: 100%;
    max-width: 1440px;

    &__box {
        position: relative;
        display: flex;
        width: 91.66%;
        padding: 5%;
        background-color: $color-black-5;
        z-index: 2;
        box-shadow: 70px 0 120px -20px rgba(0, 0, 0, 0.2);

        &-content {
            margin-left: 4%;
        }

        &--variant-blue {
            background-color: $color-blue-2;
            color: white;

            .ux-button {
                color: var(--ux-button-hover-text-color);
                border-color: var(--ux-button-hover-text-color);

                &:hover {
                    color: var(--ux-button-hover-bg-color) !important;
                    background-color: var(
                        --ux-button-hover-text-color
                    ) !important;
                    border-color: var(--ux-button-hover-text-color) !important;
                }
            }
        }
    }

    &__box-bg {
        position: absolute;
        width: 91.66%;
        height: 100%;
        background-color: $color-blue-5;
        right: 0;
        bottom: -5%;

        @media only screen and (min-width: $tablet) {
            bottom: -15%;
        }
    }
}

/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
